
<section style="overflow-y: scroll;height: 100%;">
  <div class="wrapper">

  <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
  <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 74%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
  <button type="button" class="add-boutton" style="left: 83%;" name="Add" [disabled]="disablepharnacy" (click)="openDialog()">Add</button>


</div>

<BR>
<BR>

  <div class="wrapper">
    <div class="styled-input">
      <table style="left: 50px; width: 100%;">
        <tr *ngFor="let item of cancertreatmentList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;">

          <td style="width: 100%;">
            <div >
              <label style="font-weight: bold;" [hidden]="hiddenhead"><u>{{item.trdate}} {{item.username}} </u></label>  <label >{{trlocationtext[i]}}</label>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
              <div>
                <label style="font-weight: bold; color: rgb(0, 0, 168);">{{item.trtype}}  </label>
                <!-- <label style="font-weight: bold;">{{item.wk_kind}} </label><label>{{item.trkind}} <label>{{item.wk_trcycleno}}</label> {{item.trcycleno}}{{item.trdayscycle}}{{item.trstartdate}}{{wk_title_of_dos}}{{item.trdose}},{{wk_title_of_Fractionation}},{{item.trfrac}}{{wk_title_of_Dose_Fraction}}{{item.trdosefrac}}{{item.trnotes}}{{item.wk_Pervious}}</label> -->
                <label style="font-weight: bold;"> </label><label>►{{item.trkind}}<label>,{{item.trdoseunit}},{{item.trdosemodtext}},{{item.wk_trcycleno}}</label>, {{item.trcycleno}},{{item.trdayscycle}}{{item.trstartdate}}{{wk_title_of_dos}},{{wk_title_of_Fractionation}}{{item.wk_title_of_Dose_FractionText}}{{item.trnotes}}{{item.wk_Pervious}}</label>
                <!-- {{item.wk_kind}} -->
                <br>
              </div>

              <div style="display: flex; gap: 10px;">
                <button class="fa fa-pencil" style="border-style: none; background-color: white; color: green;"
                  matTooltip="Edit" name="Add" [disabled]="disablepharnacy" (click)="EditDecision(item)">
                </button>
                <button class="fa fa-trash" style="border-style: none; background-color: white; color: red;"
                  matTooltip="Delete" name="Delete" [disabled]="disablepharnacy" (click)="MessegeDelete(item)">
                </button>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</section>





